var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{},[_c('button',{staticClass:"  text-green-primary font-bold relative outcome",attrs:{"data-tippy-content":this.body}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }